"use client";
import React, { useEffect, useState } from "react";
export default function Navigation({ currentSection, handleScrollToSection }) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setIsScrolled(offset > 830); // Change to true if scrolled down
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`top-0 left-0 z-50 fixed flex items-center justify-around w-full h-[90px] transition-all duration-300 ${
        isScrolled ? "bg-red-600 text-[#D4D4D4]" : "bg-white text-[#7A7A7A]"
      }`}
    >
      <img
        className=""
        src={
          isScrolled
            ? "/icons/navigation/1-white.svg"
            : "/icons/navigation/1.svg"
        } // Swap the icon based on scroll state
        alt="logo"
      />
      <div className="flex gap-[38px] cursor-pointer font-normal">
        <h2
          className={` ${
            currentSection === "about-us" && isScrolled
              ? "text-[#FFFFFF] font-bold"
              : ""
          }
          ${!isScrolled ? "text-[#EB2027] font-extrabold" : ""}
          
          `}
          onClick={() => handleScrollToSection("about-us")}
        >
          ABOUT US
        </h2>
        <h2
          className={`${
            currentSection === "services" ? "text-[#FFFFFF] font-bold" : ""
          }`}
          onClick={() => handleScrollToSection("services")}
        >
          OUR SOLUTIONS
        </h2>
        <h2>CASE STUDY</h2>
        <h2>CAREERS</h2>
        <h2
          className={`nav-item ${
            currentSection === "contact-us" ? "text-[#FFFFFF] font-bold" : ""
          }`}
          onClick={() => handleScrollToSection("contact-us")}
        >
          CONTACT US
        </h2>
      </div>
      <div
      className="flex justify-center items-center">
        <img
          src={"/icons/navigation/languague.png"} // Swap the icon based on scroll state
          alt="logo"
        />
      </div>
    </div>
  );
}
